import { __exports as s } from "./contact-channels224.js";
import { __require as C } from "./contact-channels161.js";
import { __require as d } from "./contact-channels225.js";
var m;
function N() {
  if (m) return s;
  m = 1, Object.defineProperty(s, "__esModule", { value: !0 }), s.formatAttributes = f, s.escapeSpecialCharacters = h, s.revertEscapedCharacters = _, s.formatDOM = E;
  var o = /* @__PURE__ */ C(), u = d();
  function v(r) {
    return u.CASE_SENSITIVE_TAG_NAMES_MAP[r];
  }
  function f(r) {
    for (var t = {}, n = 0, a = r.length; n < a; n++) {
      var e = r[n];
      t[e.name] = e.value;
    }
    return t;
  }
  function p(r) {
    r = r.toLowerCase();
    var t = v(r);
    return t || r;
  }
  function h(r) {
    return r.replace(u.CARRIAGE_RETURN_REGEX, u.CARRIAGE_RETURN_PLACEHOLDER);
  }
  function _(r) {
    return r.replace(u.CARRIAGE_RETURN_PLACEHOLDER_REGEX, u.CARRIAGE_RETURN);
  }
  function E(r, t, n) {
    t === void 0 && (t = null);
    for (var a = [], e, c = 0, A = r.length; c < A; c++) {
      var i = r[c];
      switch (i.nodeType) {
        case 1: {
          var R = p(i.nodeName);
          e = new o.Element(R, f(i.attributes)), e.children = E(
            // template children are on content
            R === "template" ? i.content.childNodes : i.childNodes,
            e
          );
          break;
        }
        case 3:
          e = new o.Text(_(i.nodeValue));
          break;
        case 8:
          e = new o.Comment(i.nodeValue);
          break;
        default:
          continue;
      }
      var l = a[c - 1] || null;
      l && (l.next = e), e.parent = t, e.prev = l, e.next = null, a.push(e);
    }
    return n && (e = new o.ProcessingInstruction(n.substring(0, n.indexOf(" ")).toLowerCase(), n), e.next = a[0] || null, e.parent = t, a.unshift(e), a[1] && (a[1].prev = a[0])), a;
  }
  return s;
}
export {
  N as __require
};
//# sourceMappingURL=contact-channels206.js.map
